export enum EFieldValueFormat {
  RAW = "RAW",
  TITLE_CASE = "TITLE_CASE",
  ACTIVATION_LINK = "ACTIVATION_LINK",
  ACTIVATION_STATUS = "ACTIVATION_STATUS",
  TOGGLE_STATE = "TOGGLE_STATE"
}
